exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".from-s[data-v-4bed1e00]{display:inline-block}[data-v-4bed1e00] .el-form-item{margin-bottom:20px}\n", ""]);

// exports
